// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__2KBne","buttons":"PendingPaymentAlert_buttons__2GJBs"};